import {api} from '../api.request';


const highestReturnFrequencyGoods=function(o){
   return api.get("/bottom/highestReturnFrequencyGoods",o)
} 
const mostShopsReturnGoods=function(o){
   return api.get("/bottom/mostShopsReturnGoods",o)
} 

export default {
    highestReturnFrequencyGoods,
    mostShopsReturnGoods
}